export default "__VITE_ASSET__BBdSPqVs__"